module.exports = __webpack_public_path__ + "img/a_logo@2x.a7885203.png";